import { useEffect, useRef, useState } from "react";
import { motion, useInView, useMotionValue, animate } from "framer-motion";
import { STATS } from "../../data/content";
import { HOME } from "../../constants/testIds";

function CountUp({ to, suffix }) {
  const [display, setDisplay] = useState("0");
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const mv = useMotionValue(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(mv, to, {
      duration: 1.8,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => {
        const n = to >= 1000 ? Math.round(v).toLocaleString("en-IN") : Math.round(v).toString();
        setDisplay(n);
      },
    });
    return () => controls.stop();
  }, [inView, to, mv]);

  return (
    <span ref={ref} className="text-[#C9A961]">
      {display}
      {suffix}
    </span>
  );
}

export default function StatsStrip({ dark = false }) {
  const bg = dark ? "bg-[#1A100D] text-[#FDFBF6]" : "bg-[#FDFBF6] text-[#3B1F1A]";
  return (
    <section data-testid={HOME.statsStrip} className={`relative ${bg} py-16 md:py-24 border-y border-[#C9A961]/25`}>
      <div className="absolute inset-0 dot-grid opacity-[0.35] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative grid grid-cols-2 md:grid-cols-4 gap-8">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ delay: i * 0.08, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="text-center md:text-left"
          >
            <div className="font-serif font-light text-5xl md:text-6xl leading-none">
              <CountUp to={s.k} suffix={s.suffix} />
            </div>
            <div className="mt-3 text-[11px] uppercase tracking-[0.28em] opacity-70">
              {s.label}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
